const salesVoucherTypes = {
  '01': true,
  '04': true,
  '09': true,
  10: true
}

export { salesVoucherTypes }
